import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const availabilityRoute: InvariantJiraRoute = {
	name: 'servicedesk-availability',
	path: '/jira/servicedesk/projects/:projectKey/availability',
	exact: true,
};
